const CHAVE_JANELA = "__milkyMooJanela";

type JanelaRegistrada = {
  id: string;
  fechar: () => void;
};

const janelas: JanelaRegistrada[] = [];
let proximoId = 0;
let ignorarProximoPop = 0;
let retornoFisicoDeJanela = false;
let ouvinteInstalado = false;

function estadoAtual(): Record<string, unknown> {
  const atual = window.history.state;
  return atual && typeof atual === "object" ? (atual as Record<string, unknown>) : {};
}

function instalarOuvinte() {
  if (ouvinteInstalado) return;
  ouvinteInstalado = true;

  window.addEventListener("popstate", (evento) => {
    if (ignorarProximoPop > 0) {
      ignorarProximoPop -= 1;
      return;
    }

    const janelaDoTopo = janelas.at(-1);
    if (janelaDoTopo) {
      // Consome o retorno físico antes que outro listener navegue para a rota
      // anterior; o fechamento da janela deve revelar o nível abaixo.
      evento.stopImmediatePropagation();
      evento.preventDefault();
      // O botão físico já removeu a entrada do topo. Não fazemos outro
      // history.back no cleanup, pois isso consumiria a janela anterior.
      retornoFisicoDeJanela = true;
      janelaDoTopo.fechar();
    }
  }, true);
}

/** Informa ao layout que a troca de rota foi causada pelo back de uma janela. */
export function consumirRetornoFisicoDeJanela() {
  const retorno = retornoFisicoDeJanela;
  retornoFisicoDeJanela = false;
  return retorno;
}

/**
 * Cria um nível no histórico para cada janela aberta. Assim, o botão Voltar
 * do Android fecha somente a janela do topo, sem sair ou recarregar a página.
 */
export function registrarJanelaNoHistorico(fechar: () => void) {
  instalarOuvinte();

  proximoId += 1;
  const id = `janela-${proximoId}`;
  const registro = { id, fechar };
  janelas.push(registro);
  window.history.pushState({ ...estadoAtual(), [CHAVE_JANELA]: id }, "", window.location.href);

  return () => {
    const indice = janelas.findIndex((janela) => janela.id === id);
    if (indice >= 0) janelas.splice(indice, 1);

    // Se a janela foi fechada por ESC, botão ou seta, também elimina seu nível
    // artificial sem fechar a janela imediatamente abaixo.
    if (estadoAtual()[CHAVE_JANELA] === id) {
      ignorarProximoPop += 1;
      window.history.back();
    }
  };
}
